import type { TableView } from 'api/models/TableView';
import { TableView as TableViewEnum } from 'api/models/TableView';
import type { TableViewListResponse } from 'api/models/TableViewListResponse';
import { ApiService } from 'api/services/ApiService';

const VIEW_TYPE = TableViewEnum.view_type.MODELS;

export const listModelsTableViews = (): Promise<TableViewListResponse> =>
  ApiService.apiDashboardWorkboardTableViewsList(VIEW_TYPE);

export const createModelsTableView = (data: TableView): Promise<TableView> =>
  ApiService.apiDashboardWorkboardTableViewsCreate(data, VIEW_TYPE);

export const updateModelsTableView = (id: string, data: Partial<TableView>): Promise<TableView> =>
  ApiService.apiDashboardWorkboardTableViewsPartialUpdate(id, data as TableView);

export const deleteModelsTableView = (id: string): Promise<void> =>
  ApiService.apiDashboardWorkboardTableViewsDelete(id);
